import apiClient from './client';

export interface IngestResponse {
  job_id: string;
  queue_job_id: string | number | undefined;
  archive_hash: string;
}

export interface BatchIngestResponse {
  results: Array<IngestResponse & {
    chapter_no?: number;
    filename?: string;
    dedup?: boolean;
    requeued?: boolean;
    error?: string;
  }>;
  total: number;
  successful: number;
  failed: number;
}

export const ingestApi = {
  upload: async (
    file: File,
    seriesId?: string,
    chapterNo?: number,
    telegramId?: number
  ): Promise<IngestResponse> => {
    const formData = new FormData();
    formData.append('file', file);

    const params = new URLSearchParams();
    if (seriesId) params.append('series_id', seriesId);
    if (chapterNo !== undefined) params.append('chapter_no', chapterNo.toString());
    if (telegramId) params.append('telegram_id', telegramId.toString());

    // IMPORTANT: Do NOT set Content-Type manually for multipart/form-data in the browser.
    // Axios will set it with the correct boundary.
    // Increase timeout for large files (30 minutes; large archives over slow links
    // exceeded the old 5-min axios cap -> HTTP/2 CANCEL -> backend premature close -> 502)
    const response = await apiClient.post<IngestResponse>(`/ingest?${params.toString()}`, formData, {
      timeout: 30 * 60 * 1000, // 30 minutes
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });
    return response.data;
  },

  uploadBatch: async (
    files: File[],
    seriesId?: string,
    chapterNos?: number[],
    telegramId?: number
  ): Promise<BatchIngestResponse> => {
    const formData = new FormData();
    
    // Add all files
    files.forEach((file) => {
      formData.append('file', file);
    });

    const params = new URLSearchParams();
    if (seriesId) params.append('series_id', seriesId);
    if (chapterNos && chapterNos.length > 0) {
      params.append('chapter_nos', chapterNos.join(','));
    }
    if (telegramId) params.append('telegram_id', telegramId.toString());

    // Increase timeout for batch uploads (30 minutes for multiple large files)
    const response = await apiClient.post<BatchIngestResponse>(`/ingest/batch?${params.toString()}`, formData, {
      timeout: 30 * 60 * 1000, // 30 minutes
      maxContentLength: Infinity,
      maxBodyLength: Infinity,
    });
    return response.data;
  },
};




